import { C } from "../../common/component";
import { Helper } from "../../common/helper";
import { Icon, IconHelper } from "../../common/icon-helper";
import { Dialog } from "../../common/dialog";
import { Txt } from "../../common/text";
import { EditControl } from "../form-row";
import { Requester } from "../../common/requester";
import { SuggestionsDropdown } from "./suggestions-dropdown";

export class TranslationsEditControl implements EditControl
{
    private readonly inputRow: JQuery;
    private readonly inputs: { [code: string]: JQuery } = {};
    private readonly getRowValue: (rowName: string) => any;

    constructor(typeData: any, getRowValue: (rowName: string) => any = _ => null)
    {
        this.getRowValue = getRowValue;
        this.inputRow = C.div.css("position", "relative");
        const languages: { [code: string]: string } = typeData.Languages;
        const numberOfTextBoxRows = typeData.NumberOfTextBoxRows;
        function getInput()
        {
            if (numberOfTextBoxRows && numberOfTextBoxRows > 1)
            {
                return C.textarea.addClass("w-form-control").attr("rows", numberOfTextBoxRows);
            }
            return C.input.addClass("w-form-control").attr("type", "text");
        }
        this.inputs["default"] = getInput();
        for (const language in languages)
        {
            this.inputs[language] = getInput();
        }

        const inputGroup = C.div.addClass("w-input-group").appendTo(this.inputRow);
        this.inputs["default"].appendTo(inputGroup);
        const addon = C.span.addClass("w-input-group-addon").appendTo(inputGroup);
        C.span.addClass(IconHelper.getIconClass(Icon.language)).appendTo(addon);

        let modal: Dialog;
        addon.click(() =>
        {
            if (!modal)
            {
                modal = new Dialog(typeData.Title);
                for (const language in languages)
                {
                    const group = C.div.addClass("w-form-group").appendTo(modal.body);
                    C.label.text(languages[language]).addClass("control-label").appendTo(group);
                    this.inputs[language].appendTo(group);
                }
                C.button.addClass("w-button-primary main-button").attr("type", "button").text(Txt.close)
                    .click(() => modal.hide()).appendTo(modal.body);
            }
            modal.show();
        });

        if (typeData?.SearchUrl)
        {
            new SuggestionsDropdown(this.inputs["default"][0] as HTMLInputElement, this.inputRow[0], async (term) =>
            {
                const params = { search: term };
                if (typeData.SearchParameter)
                {
                    const value = this.getRowValue(typeData.SearchParameter);
                    if (Helper.hasValue(value))
                    {
                        params[typeData.SearchParameter] = value;
                    }
                }
                return await Requester.get(typeData.SearchUrl, params);
            });
        }
    }

    initialize(parent: HTMLElement)
    {
        parent.append(this.inputRow[0]);
    }

    async setValue(value: string)
    {
        const dict = value ? JSON.parse(value) : {};
        for (const language in this.inputs)
        {
            this.inputs[language].val(dict[language]);
        }
    }

    getValue()
    {
        if (!this.inputs["default"].val())
        {
            return null;
        }
        const result = {};
        for (const language in this.inputs)
        {
            result[language] = this.inputs[language].val().toString();
        }
        return JSON.stringify(result);
    }

    onChange(action: () => void)
    {
        this.inputs["default"].on("change", action);
    }

    focus()
    {
        this.inputs["default"].focus();
    }
}
